const KEY_PHASOR_BINDING_START = 0x10001;
const KEY_PHASOR_HZ_BINDING_START = 0x11001;
const TRAIN_PARAMETER_BINDING_START = 0x20001;
const BINDING_RANGE_SIZE = 100;

const optionIdWithinRange = (bindingParam: number, start: number, prefix: string): string | null => {
  const index = bindingParam - start;

  return index >= 0 && index < BINDING_RANGE_SIZE ? `${prefix}_${index}` : null;
};

export const getTrainParameterOptionId = (bindingParam: number | null): string | null => {
  if (bindingParam === null || !Number.isInteger(bindingParam)) {
    return null;
  }

  return (
    optionIdWithinRange(bindingParam, KEY_PHASOR_BINDING_START, "keyphasor") ??
    optionIdWithinRange(bindingParam, KEY_PHASOR_HZ_BINDING_START, "keyphasor") ??
    optionIdWithinRange(bindingParam, TRAIN_PARAMETER_BINDING_START, "parameter")
  );
};
